import { types } from '../types'

const initialState = {
  Waiting: false,
  Success: false,
  Error: '',
  user: {},
  displayToast: false,
  isSetPassword: false.valueOf,
  IsUserHasPassword: false.valueOf,
  IsSendVerificationCode: false.valueOf,
  loginPostEmailSuccess: false,
  registerPostEmailSuccess: false,
  sendVeridictionCodeSuccess: false,
  sendRegisterVerifictionCodeSuccess: false,
  Token: '',
  companies: {}
}

const userReducer = (state = initialState, { type, action, error }) => {
  switch (type) {
    //************************************************************************ */
    case types.LOGIN_REQUEST: {
      return {
        ...state,
        Waiting: true,
        loginPostEmailSuccess: false,


      }
    }
    case types.LOGIN_REQUEST_SUCCESS: {
      return {
        ...state,
        Waiting: false,
        loginPostEmailSuccess: true,
        IsUserHasPassword: action.data.userHasPassword,
        IsSendVerificationCode: action.data.sendVerificationCode,
      }
    }
    case types.LOGIN_REQUEST_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: action.error
      }
    }

    case types.SEND_PASSWORD_REQUEST: {
      return {
        ...state,
        Waiting: false,
        Success: false,
        Error: '',
      }
    }
    case types.SEND_PASSWORD_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        Success: true,
        UserHasPassword: action.response.data.userHasPassword,
        SendVerificationCode: action.response.data.sendVerificationCode
      }
    }
    case types.SEND_PASSWORD_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: action.data.message,
      }
    }


    case types.SEND_VERIFICTION_REQUEST: {
      return {
        ...state,
        Waiting: false,
        sendVeridictionCodeSuccess: false,
        Error: '',
      }
    }
    case types.SEND_VERIFICTION_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        sendVeridictionCodeSuccess: true,
        user: action.data
      }
    }
    case types.SEND_VERIFICTION_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }


    case types.GET_ALL_COMPANY_REQUEST: {
      return {
        ...state,
        getAllCompanyPending: true,
        getAllCompanySuccess: false,
        companies: {}

      }
    }
    case types.GET_ALL_COMPONY_SUCCESS: {


      return {
        ...state,
        getAllCompanyPending: false,
        getAllCompanySuccess: true,
        companies: action.data,

      }
    }
    case types.GET_ALL_COMPONY_ERROR: {


      return {
        ...state,
        getAllCompanyPending: false,
        Error: error.data.title,
      }
    }

    case types.REGISTER_REQUEST: {
      return {
        ...state,
        Waiting: true,
        registerPostEmailSuccess: false,
        Error: '',
      }
    }
    case types.REGISTER_REQUEST_SUCCESS: {
      return {
        ...state,
        Waiting: false,
        registerPostEmailSuccess: true,

      }
    }
    case types.REGISTER_REQUEST_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: "000000",
      }
    }


    case types.REGISTER_SEND_VERIFICTION_REQUEST: {
      return {
        ...state,
        Waiting: true,
        sendRegisterVerifictionCodeSuccess: false,
        Error: '',
      }
    }
    case types.REGISTER_SEND_VERIFICTION_SUCCESS: {

      return {
        ...state,
        Waiting: false,
        sendRegisterVerifictionCodeSuccess: true,
        user: action.data,
        Token: action.data.token
      }
    }
    case types.REGISTER_SEND_VERIFICTION_ERROR: {

      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }





    case types.LOGIN_PASSWORD_REQUEST: {
      return {
        ...state,
        Waiting: true,
        Success: false,
        Error: '',
      }
    }
    case types.LOGIN_PASSWORD_REQUEST_SUCCESS: {
      return {
        ...state,
        Waiting: false,
        Success: true,
        user: action.data
      }
    }
    case types.LOGIN_PASSWORD_REQUEST_ERROR: {
      return {
        ...state,
        Waiting: false,
        Error: "00000",
      }
    }




    case types.USER_RESET_PROPS: {
      return {
        ...state,
        Waiting: false,
        Success: false,
        Error: false,
        loginPostEmailSuccess: false,
        registerPostEmailSuccess: false,
        sendVeridictionCodeSuccess: false,
        sendRegisterVerifictionCodeSuccess: false,
        user: localStorage.getItem("sipOnlineUser") ? state.user : {}

      }
    }

    default:
      return state
  }
}

export default userReducer
